import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type Role = "system_admin" | "org-admin" | "teacher" | "learner" | null;

export type User = {
  id: number;
  email: string;
  name: string;
  role: Role;
  org_id: number | null;
  login_id?: string | null;
};

type AuthState = {
  accessToken: string | null;
  user: User | null;
  setAuth: (accessToken: string, user: User) => void;
  setAccess: (accessToken: string) => void;
  clear: () => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      user: null,
      setAuth: (accessToken, user) => set({ accessToken, user }),
      setAccess: (accessToken) => set({ accessToken }),
      clear: () => set({ accessToken: null, user: null }),
    }),
    {
      name: "nihongo-admin-auth",
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ accessToken: s.accessToken, user: s.user }),
    }
  )
);

/** 管理画面に入れる役割か */
export function isAdminRole(role: Role | undefined): role is "system_admin" | "org-admin" | "teacher" {
  return role === "system_admin" || role === "org-admin" || role === "teacher";
}

/** 役割ごとの最初の画面（spec 12章） */
export function homeFor(role: Role | undefined): string {
  if (role === "system_admin") return "/ops";
  if (role === "org-admin") return "/school";
  return "/";
}
